import React from 'react';
import { useStyles } from "../styles/styles";
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import PartyListItem from './PartyListItem';

const PartyList = (props) => {
    const partyData = props.partyData;
    const court = props.court;
    const selectParty = props.selectParty;
    const classes = useStyles;

    return (
        <>
            <Typography variant='h6' component='h2' color='primary' sx={{...classes.title, fontSize: '1.2rem', marginTop: '1rem', marginBottom: '.5rem'}}>
                Select the Correct Party
            </Typography>
            <Typography variant='subtitle1' sx={{marginBottom: '.5rem', lineHeight: '1.4rem'}}>
                Your search returned balances for multiple parties, and CitePay can only process payments for a single
                party per payment. Please select one of the parties below to continue.
            </Typography>
            <Paper elevation={3} sx={{...classes.listContainer, maxHeight: '80vh', overflow: 'auto'}}>
                <List sx={classes.list} >
                    {partyData.map((partyRec, idx) => {
                        return (
                            <>
                                <PartyListItem partyRec={partyRec} court={court} selectParty={selectParty}/>
                                { idx < (partyData.length - 1) &&
                                    <Divider sx={classes.listDivider}/>
                                }
                            </>
                        );
                    })}
                </List>

            </Paper>
        </>
    )
}

export default PartyList;
